import styled from "styled-components";
import {Form} from "antd";

export const MapContainer = styled.div`
    height: ${props => props.height || "250px"};
    overflow: hidden;
    margin: 20px 0;
    border-radius: 4px;
    pointer-events: ${props => props.disabled && "none"};
    position: relative;

    .leaflet-container {
        height: 100%;
        width: 100%;
        border-radius: 4px;
    }

    .single-marker-custom-icon {
        background: transparent;
        border: none;
    }
`;

export const FormItem = styled(Form.Item)`
    margin: 0;
`;

export const DisableMapContainer = styled.div`
    background: #9a9a9a7a;
    height: ${props => props.height || "250px"};
    position: absolute;
    width: 100%;
    margin: 20px 0;
    z-index: 2;
    cursor: not-allowed;
`;
